import { Application } from '@hotwired/stimulus';

import BidController from "./controllers/bid_controller";

window.Stimulus = Application.start();
Stimulus.register("bid", BidController);

